<a mat-list-item (click)="toggle()" >
    <div fxLayout="row" fxLayoutAlign="space-between stretch" [ngClass]="{'expandido': menuPrincipalService.expandido}">
        <div fxLayout="row" fxLayoutAlign="start stretch" matTooltip="Materiais">
            <mat-icon>account_balance</mat-icon>
            <span *ngIf="menuPrincipalService.expandido"  class="nav-caption">Materiais</span>
        </div>
        <div fxLayout="row" fxLayoutAlign="start stretch">
            <mat-icon *ngIf="menuPrincipalService.expandido" style="padding-top: 2px">{{getIcone()}}</mat-icon>
        </div>
    </div>
</a>
<mat-nav-list [ngClass]="{'expandido': menuPrincipalService.expandido}">
    <div [hidden]="!isMostrarSubMenu" [@menuState]="currentState">

    <!-- MATERIAL -->
    <sub-menu *ngIf="verificaAcesso(getModulos().MATERIAL)" icone="collections_bookmark" titulo="Bens Permanentes e de Consumo" rota="material" toolTip="Bens Permanentes e de Consumo"></sub-menu>

    <!-- COTACOES_MATERIAIS -->
    <sub-menu *ngIf="verificaAcesso(getModulos().COTACOES_MATERIAIS)" icone="trending_up" titulo="Cotações" rota="cotacoesmateriais" toolTip="Cotações"></sub-menu>

    <!-- MOVIMENTACOES_MATERIAIS -->
    <sub-menu *ngIf="verificaAcesso(getModulos().MOVIMENTACOES_MATERIAIS)" icone="sync_alt" titulo="Movimentações Bens" rota="movimentacoesmateriais" toolTip="Movimentações de Bens"></sub-menu>
   
    <!-- PEDIDOS_MATERIAIS -->
    <sub-menu *ngIf="verificaAcesso(getModulos().PEDIDOS_MATERIAIS)" icone="shopping_basket" titulo="Pedidos Materiais" rota="pedidosmateriais" toolTip="Pedidos Materiais"></sub-menu>

    <!-- ESTOQUES -->
    <sub-menu *ngIf="verificaAcesso(getModulos().ESTOQUES)" icone="apartment" titulo="Estoques" rota="estoques" toolTip="Estoques de Materiais"></sub-menu>
    
    <!-- ESTOQUES -->
    <sub-menu *ngIf="verificaAcesso(getModulos().EMPRESAS_FORNECEDORAS)" icone="group_add" titulo="Empresas Fornecedoras" rota="empresasfornecedoras" toolTip="Empresas Fornecedoras"></sub-menu>

    </div>
</mat-nav-list>

